import {
  AddIcCall,
  Alarm,
  ArrowDownward,
  Email,
  FileCopy,
  Map,
  NotInterested,
  PictureAsPdf,
  RecordVoiceOver,
  VerifiedUser,
} from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Divider,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import { useState } from "react";
import dayjs from "dayjs";

const ToPanelComponent = ({
  colors,
  isNonMobile,
  id,
  year,
  regDate,
  project,
  institute,
  contactNo,
  contactPerson,
  email,
  grandTotal,
  labTests,
  loading,
  setOpenConfirmDialog,
  data,
  setSelectedRequestId,
  setOpenReportDialog,
  setSelectedTest,
  loggedUser,
  setConfirmMessage,
  setCheckedReport,
  handleOpenReportPreview,
}) => {
  const handleCheckedRequest = (selectedTest) => {
    setSelectedRequestId(selectedTest);
    setCheckedReport(true);
    setConfirmMessage(
      "Are you sure you want to mark as checked the report?   Please note that once the report is checked, you will no longer be able to make any edits without admin approval!"
    );
    setOpenConfirmDialog(true);
  };

  const handleCompleteRequest = (selectedTest) => {
    setSelectedRequestId(selectedTest);
    setCheckedReport(false);
    setConfirmMessage(
      "Are you sure you want to finalize the report?   Please note that once the report is completed, you will no longer be able to make any edits without admin approval!"
    );
    setOpenConfirmDialog(true);
  };

  const handleEnterTestData = (testData) => {
    setSelectedTest(testData);
    setSelectedRequestId(data.labRequest);
    setOpenReportDialog(true);
  };

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ArrowDownward />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Box display="flex" flexDirection="column" sx={{ width: "100%" }}>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h5" color={colors.grey[500]}>
              {project}
            </Typography>
            <Typography variant="h5" color="error">
              {year +
                "/" +
                String(data.labRequest.autoIdByYear).padStart(4, "0")}
            </Typography>
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Card
          variant="elevation"
          elevation={4}
          sx={{
            width: "100%",
            marginBottom: "25px",
            backgroundColor: colors.grey[900],
          }}
        >
          <CardContent style={{ paddingBottom: "2px" }}>
            <Box
              display="grid"
              gap="8px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": {
                  gridColumn: isNonMobile ? undefined : "span 4",
                },
              }}
            >
              <Box
                sx={{
                  gridColumn: "span 5",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={{ width: "100%" }}
                >
                  <Box display="flex" justifyContent="space-between">
                    <Typography variant="h3" color="success">
                      Project
                    </Typography>
                    <Typography variant="h3" color="error">
                      Job No :{" "}
                      {year +
                        "/" +
                        String(data.labRequest.autoIdByYear).padStart(4, "0")}
                    </Typography>
                  </Box>
                  <Typography variant="h3" color={colors.grey[500]}>
                    {project}
                  </Typography>
                </Box>
              </Box>
              <Divider sx={{ gridColumn: "span 5" }} />
              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                <Typography variant="h5">Job register date</Typography>
                <Typography variant="h5" color="success">
                  {regDate}
                </Typography>
              </Box>
              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                <Typography variant="h5">Institute</Typography>
                <Typography variant="h5" color="success">
                  {institute}
                </Typography>
              </Box>
              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                <Typography variant="h5">Contact No</Typography>
                <Typography variant="h5" color="success">
                  {contactNo}
                </Typography>
              </Box>
              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                <Typography variant="h5">Email</Typography>
                <Typography variant="h5" color="success">
                  {email}
                </Typography>
              </Box>
              <Box
                sx={{
                  gridColumn: "span 1",
                }}
              >
                <Typography variant="h3" color="success" fontWeight={550}>
                  LKR{" "}
                  {grandTotal.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
                </Typography>
              </Box>
              <Divider sx={{ gridColumn: "span 5" }}>
                <Chip label="JOB RELATED TESTS" size="medium" />
              </Divider>

              {labTests?.map((testData, index) =>
                testData.finalized ===
                (loggedUser.position.id === 2 ? true : false) ? (
                  <Box
                    key={index}
                    elevation={4}
                    sx={{
                      width: "100%",
                      gridColumn: "span 5",
                    }}
                  >
                    <Paper
                      elevation={4}
                      sx={{
                        padding: "10px",
                        width: "100%",
                        gridColumn: "span 5",
                      }}
                    >
                      <Box
                        display="grid"
                        gap={2}
                        gridTemplateColumns="repeat(5, minmax(0, 1fr))"
                        sx={{
                          "& > div": {
                            gridColumn: isNonMobile ? undefined : "span 5",
                          },
                        }}
                      >
                        <Typography
                          sx={{ gridColumn: "span 2" }}
                          color="info"
                          variant="h5"
                        >
                          Lab Test Name
                        </Typography>
                        <Typography
                          sx={{ gridColumn: "span 1" }}
                          color="info"
                          variant="h5"
                        >
                          Quantity
                        </Typography>
                        <Typography
                          sx={{ gridColumn: "span 1" }}
                          color="info"
                          variant="h5"
                        >
                          Amount
                        </Typography>
                        <Typography
                          sx={{ gridColumn: "span 1" }}
                          color="info"
                          variant="h5"
                        >
                          Total
                        </Typography>
                        <Typography variant="h5" sx={{ gridColumn: "span 2" }}>
                          {testData.labTest.testName}
                        </Typography>
                        <Typography variant="h5" sx={{ gridColumn: "span 1" }}>
                          {testData.quantity.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          })}{" "}
                          Nos
                        </Typography>
                        <Typography variant="h5" sx={{ gridColumn: "span 1" }}>
                          {testData.labTest.amount.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          })}
                        </Typography>
                        <Typography variant="h5" sx={{ gridColumn: "span 1" }}>
                          {testData.total.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          })}
                        </Typography>
                        <Divider sx={{ gridColumn: "span 5" }} />

                        <Box
                          display="flex"
                          justifyContent="space-between"
                          sx={{ gridColumn: "span 5" }}
                        >
                          <Box
                            display="flex"
                            gap={1}
                            sx={{ gridColumn: "span 5" }}
                          >
                            <Email color="warning" />
                            <Typography variant="h5" color="info">
                              {`Report Collect - ${testData.reportCollectMethod}`}
                            </Typography>
                            <Map color="warning" />
                            <Typography variant="h5" color="info">
                              {`Sample - ${testData.sampleCollectMethod}`}
                            </Typography>
                            <Alarm color="error" />
                            <Typography variant="h5" color="error">
                              {"Complete within - " +
                                testData.labTest.estimatedTime +
                                " Days"}
                            </Typography>
                          </Box>

                          {loggedUser.position.id === 4 ? (
                            <Box gap={1} display="flex" alignItems="center">
                              {" "}
                              <Button
                                type="button"
                                startIcon={<FileCopy />}
                                color="warning"
                                loading={loading}
                                variant="contained"
                                onClick={() => handleEnterTestData(testData)}
                                sx={{ margin: "5px 0 5px 0" }}
                              >
                                Edit REPORT
                              </Button>
                              <Button
                                type="button"
                                startIcon={<VerifiedUser />}
                                color="success"
                                loading={loading}
                                variant="contained"
                                onClick={() => handleCompleteRequest(testData)}
                                sx={{ margin: "5px 0 5px 0" }}
                              >
                                FINALIZE
                              </Button>
                            </Box>
                          ) : (
                            ""
                          )}

                          {loggedUser.position.id === 2 ? (
                            <Box gap={1} display="flex" alignItems="center">
                              {" "}
                              <IconButton
                                title="View Report"
                                aria-label="add an alarm"
                                onClick={() => {
                                  console.log(
                                    "----- tis is data ",
                                    data.labRequest
                                  );
                                  setSelectedRequestId(data.labRequest);
                                  handleOpenReportPreview();
                                }}
                              >
                                <PictureAsPdf
                                  color="info"
                                  sx={{ fontSize: "25px" }}
                                />
                              </IconButton>
                              <Button
                                type="button"
                                startIcon={<VerifiedUser />}
                                color="success"
                                loading={loading}
                                variant="contained"
                                onClick={() => handleCheckedRequest(testData)}
                                sx={{ margin: "5px 0 5px 0" }}
                              >
                                CHECKED
                              </Button>
                              <Button
                                type="button"
                                startIcon={<NotInterested />}
                                color="error"
                                loading={loading}
                                variant="contained"
                                onClick={() => handleCompleteRequest(testData)}
                                sx={{ margin: "5px 0 5px 0" }}
                              >
                                REJECT
                              </Button>
                            </Box>
                          ) : (
                            ""
                          )}
                        </Box>
                      </Box>
                    </Paper>
                  </Box>
                ) : (
                  ""
                )
              )}
            </Box>
          </CardContent>
          <Divider sx={{ marginTop: "5px" }} />
          <CardActions
            sx={{
              margin: 0,
              paddingTop: "0px",
              paddingBottom: "0px",
              justifyContent: "space-between",
            }}
          >
            <Box display="flex" alignItems="center" padding="10px">
              <RecordVoiceOver color="warning" />
              <Typography
                sx={{ marginLeft: "5px" }}
                variant="h5"
                color="success"
              >
                {contactPerson}
              </Typography>
              <AddIcCall sx={{ marginLeft: "25px" }} color="warning" />
              <Typography
                sx={{ marginLeft: "5px" }}
                variant="h5"
                color="success"
              >
                {`${contactNo ? contactNo : "-"}`}
              </Typography>
            </Box>
          </CardActions>
        </Card>
      </AccordionDetails>
    </Accordion>
  );
};
export default ToPanelComponent;
